import { render, staticRenderFns } from "./choosePro.vue?vue&type=template&id=d2b0b428&"
import script from "./choosePro.vue?vue&type=script&lang=js&"
export * from "./choosePro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports